// @flow
import React from "react";
import classNames from "classnames";
import { withGlobalContext } from "../../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";

import Info from "./TwoLevel/Info";
import OfficeInfo from "./TwoLevel/OfficeInfo";
import ContactInfo from "./TwoLevel/ContactInfo";
import Copyright from "./Copyright";

import type { $Agent, $Site, $Team } from "flow/types";

type $Props = {
  agent: $Agent,
  classes: Object,
  site: $Site,
  team: $Team,
};

const TwoLevel = ({ agent, classes, site, team }: $Props) => {
  return (
    <footer className={classes.root}>
      <div className={classes.topContainer}>
        {!site.officeId ? (
          <div className={classes.column}>
            <Info />
          </div>
        ) : null}
        {(site.userId && agent) || (site.teamId && team) ? (
          <div className={classes.column}>
            <ContactInfo />
          </div>
        ) : null}
        <div className={classNames(classes.column, classes.officeInfo)}>
          <OfficeInfo />
        </div>
      </div>
      <div className={classes.bottomContainer}>
        <Copyright />
        <div className={classes.google}>
          <div id="google_translate_element" />
        </div>
      </div>
    </footer>
  );
};

const styles = (theme) => {
  return {
    root: {
      display: "flex",
      position: "relative",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-start",
      backgroundColor: theme.colors.gray["900"],
    },
    topContainer: {
      display: "flex",
      flexFlow: "row wrap",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      padding: "13px 0",
      backgroundColor: theme.colors.gray["800"],
    },
    column: {
      flex: "0 0 100%",
      margin: "12px 0",
      textAlign: "center",
      color: theme.colors.white,
      [theme.breakpoints(628)]: {
        flex: "0 0 33.333%",
      },
    },
    bottomContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      padding: "26px 0 20px",
      color: theme.colors.white,
    },
    google: {
      marginTop: theme.spacing.unit * 1.5,
    },
    officeInfo: {
      display: "flex",
      justifyContent: "center",
      flex: "0 0 100% !important",
      flexFlow: "wrap",
      "& > div": {
        padding: `0 ${theme.spacing.unit * 1.5}px ${theme.spacing.unit *
          1.5}px ${theme.spacing.unit * 1.5}px`,
      },
    },
  };
};

export default withGlobalContext(withStyles(styles)(TwoLevel));
